import { useState, useEffect, useContext } from 'react';
import { projectMap, flipMapSteps as flipSteps } from '../schemas/stepMap';
import { UNSAFE_LocationContext as locationContext } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const getLocationInfo = (path, map) => {
  if (!map) return {};
  const steps = map.map;
  const locationInfo = {};

  const stepIndex = steps.findIndex((step) =>
    step.pathName === 'summary'
      ? path.includes(step.pathName)
      : path.endsWith(step.pathName)
  );

  if (stepIndex < 0) return locationInfo;

  locationInfo.curr = steps[stepIndex];

  if (stepIndex > 0) {
    locationInfo.prev = steps[stepIndex - 1];
  }

  if (stepIndex < steps.length - 1) {
    locationInfo.next = steps[stepIndex + 1];
  }

  return locationInfo;
};

// get all the steps that have a walkthrough, put them into a flat array
let brrrrMap = [];
const iterator = projectMap[Symbol.iterator]();
for (const step of iterator) {
  if (step[1].walkthrough && !step[1].sharing) {
    brrrrMap.push(...step[1].todo);
  }
}

let flipMap = [];
const flipIterator = flipSteps[Symbol.iterator]();
for (const step of flipIterator) {
  if (step[1].walkthrough && !step[1].sharing) {
    flipMap.push(...step[1].todo);
  }
}

flipMap = { map: flipMap, type: 'flip' };
brrrrMap = { map: brrrrMap, type: 'user' };
const sharingMap = { map: projectMap.get('sharing').todo, type: 'sharing' };
const flipSharingMap = {
  map: flipSteps.get('sharing').todo,
  type: 'flip-sharing',
};

export function useSteps(type = 'brrrr') {
  const isFlip = type === 'flip';
  const [steps, setSteps] = useState({});
  const [map, setMap] = useState(type === 'brrrr' ? brrrrMap : flipMap);
  const { location } = useContext(locationContext);
  const navigate = useNavigate();

  const changeStep = (to, from) => {
    let path = '../' + to;

    if (from?.includes('summary') && !to.includes('summary')) {
      path = '../../' + to;
    }

    if (location.pathname.includes('sharing') && map.type !== 'flip-sharing') {
      path = '../../' + to;
    }
    navigate(path);
  };

  useEffect(() => {
    const path = location.pathname;

    if (path.includes('sharing')) {
      isFlip ? setMap(flipSharingMap) : setMap(sharingMap);
    } else {
      isFlip ? setMap(flipMap) : setMap(brrrrMap);
    }

    const { prev, curr, next } = getLocationInfo(path, map);

    if (prev) {
      prev.back = () => changeStep(prev.pathName, curr.pathName);
    }

    if (next) {
      next.next = () => changeStep(next.pathName, curr.pathName);
    }

    setSteps({ prev, curr, next });
  }, [map, location.pathname]);

  return steps;
}
